import { Toolbar } from "primereact/toolbar";
import styles from './styles.module.css'
import DatePicker from "../datePicker/DatePicker";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { requestUpdateManualTimeRequest } from "../../services/wisdomServices/requestService";
import { getSessionItem } from "../../utils/helper/session";
import { useEffect, useRef, useState } from "react";
import { FilterMatchMode } from "primereact/api";
import { getAgentProjectsRequest } from "../../services/wisdomServices/projectService";
import { RejectReasonDialog } from "../rejectReasonDialog/RejectReasonDialog";
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Link } from "react-router-dom";
import { Can, PERMISSIONS } from "../../security";

export function ManualTimesTable({data, onDateSelect, onApproveRequest, onRejectRequest, loadingRequests}){
    const user = getSessionItem('User')
    const projectsRef = useRef([]);
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [rejectRequest, setRejectRequest ] = useState(null)
    const [loading, setLoading] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [projects, setProjects] = useState([])
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        date: { value: null, matchMode: FilterMatchMode.DATE_IS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        project: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
    })
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const closeDialog = () => setOpenRejectDialog(false);
   
    /**
     * Toolbar template rendered on the left side.
     *
     * @returns {JSX.Element}
     */

     /**
     * Triggers data reload based on selected month and year.
     */
    const handleFindRequests = async() => {
        onDateSelect(selectedMonth, selectedYear)
    }


     /**
     * Handles month selection change.
     *
     * @param {number} month
     */
    const handleMonthChange = async(month) => {
        setSelectedMonth(month)
    }

    /**
     * Handles year selection change.
     *
     * @param {number} year
     */
    const handleYearChange = async(year) => {
        setSelectedYear(year)
    }


    const userColumnTemplate = (rowData) => {
        return(
            <Link
                to={`/manager/user-requests/${rowData.userId}`}
                className={styles.manualTimeUserLink}
            >
            {rowData.name}
            </Link>
        )
    }

    /**
     * Toolbar template rendered on the left side.
     *
     * @returns {JSX.Element}
     */
    const leftToolbarTemplate = () => {
        return (
            <div className={styles.headerActions}>
                <DatePicker onMonthChange={handleMonthChange} onYearChange={handleYearChange}/>
                <Can permission={PERMISSIONS.requestsPending_get}>
                    <Button label='Search' icon="pi pi-check" severity='success' loading={loadingRequests} onClick={handleFindRequests} style={{borderRadius:"7px"}}/>
                </Can>
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </div>
        );
    }


    const handleRejectRequest = (rowData) => {
        setRejectRequest(rowData);
        setOpenRejectDialog(true);
    }

     /**
     * Renders the Status column content.
     *
     * @returns {JSX.Element}
     */
    const statusBodyTemplate = (rowData) => {
        return (
            <div className={styles.tableActionBtns}>
                <Can permission={PERMISSIONS.requestsManualTimeUsersByUseridByRequestid_patch}>
                    <Tag className={styles.actionBtns} value="Approve" severity="success" onClick={() => handleSubmitRequest(rowData)}/>
                    <Tag className={styles.actionBtns} value="Reject" severity="danger" onClick={() => handleRejectRequest(rowData)}/>
                </Can>
            </div>
        )
    }
    
    const loadProjects = async() => {
        try {
            const projectsList = await getAgentProjectsRequest(user.id, false, true, 1, 100)
            setProjects(projectsList.data)
            
        } catch (error) {
            console.error(error)
        }
    }

    const handleSubmitRequest = async(rowData) => {
        await onApproveRequest(rowData)
    }

    const handleRejectReasonSelect = async(reason) => {
        try {
            const body = {
                status:"rejected",
                reason
            }
    
            await requestUpdateManualTimeRequest(rejectRequest.userId, rejectRequest.id, body)
            
        } catch (error) {
            console.error(error)
        } finally{
            await onRejectRequest(rejectRequest.id)
        }
    }

    useEffect(() => {
        const init = async () => {
            try {
                setLoading(true);
                await loadProjects();
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);

    useEffect(() => {
        projectsRef.current = projects;
    }, [projects]);


    return(
        <div>
            <div className="card">
                <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate}/>
                <DataTable 
                loading={loading || loadingRequests}
                value={data} 
                paginator 
                rows={25} 
                dataKey="id" 
                stripedRows
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                filterDisplay="row"
                globalFilterFields={['date', 'name', 'project']}
                > 
                    <Column field="date" header="Date" sortable/>
                    <Column header="User" body={userColumnTemplate} sortable/>
                    <Column field="project" header="Project" sortable/>
                    <Column field="hours" header="Hours" sortable/>
                    <Column field="reason" header="Reason" sortable/>
                    <Column header="Status" body={statusBodyTemplate} sortable/>
                </DataTable>
            </div>
            <RejectReasonDialog 
                onReject={handleRejectReasonSelect}
                type="manualTime"
                open={openRejectDialog}
                onClose={closeDialog}
            />

        </div>
    )
}

export default ManualTimesTable;